import { serialize } from "../../../utils";

export default {
  namespaced: true,
  state: {
    path: "aljabr/jurist/salary-ranks",
  },
  actions: {
    get({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/?${serialize(options)}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
  },
};
